import * as React from 'react';
import {
  FormGroup,
  FormControlLabel,
  Checkbox as MUICheckbox,
  Typography,
  useTheme,
} from '@mui/material';

interface CheckboxProps {
  checked?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: any;
  testId?: string;
  name?: string;
  size?: 'small' | 'medium' | undefined;
}

export function Checkbox({
  checked,
  onChange,
  label,
  testId,
  name,
  size = 'small',
}: CheckboxProps) {
  const theme = useTheme();
  return (
    <FormGroup>
      <FormControlLabel
        control={
          <MUICheckbox
            data-testid={testId}
            name={name}
            checked={checked || false}
            id={name}
            title={name}
            onChange={(event) => onChange(event)}
            size={size}
            sx={{ color: theme.palette.text.primary }}
          />
        }
        label={<Typography variant="body2">{label}</Typography>}
      />
    </FormGroup>
  );
}
